import React from 'react';

import { useTelemetry } from '@order/Telemetry';

export const usePromoCodeTelemetry = () => {
  const { track } = useTelemetry();

  const onMonitoredPromoCodeApplied = React.useCallback(() => {
    track('payment_credit.code_applied');
  }, [track]);

  const onMonitoredPromoCodeFailed = React.useCallback(
    (userError?: string, systemError?: string) => {
      track('payment_credit.code_failed', { userError, systemError });
    },
    [track],
  );

  return {
    onMonitoredPromoCodeApplied,
    onMonitoredPromoCodeFailed,
  };
};
